import styled from 'styled-components';
import { Card, Box, Typography } from '@mui/material';

export const StyledServiceCard = styled(Card)`
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 16px;
  background-color: #ffffff;
  border: 1px solid rgba(26, 26, 46, 0.07);
  box-shadow: 0 2px 10px rgba(26, 26, 46, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  width: 100%;
  max-width: 380px;
  min-height: 320px;
  max-height: 460px;
  flex-shrink: 0;
  cursor: pointer;
  overflow: hidden;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(13, 78, 254, 0.12);
    border-color: rgba(13, 78, 254, 0.25);
  }
`;

export const AccentBar = styled(Box)`
  height: 4px;
  width: 100%;
  flex-shrink: 0;
`;

export const CardInner = styled(Box)`
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const BusinessHeader = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
`;

export const BusinessLogo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  object-fit: cover;
  background-color: #f1f5f9;
  border: 1px solid rgba(0, 0, 0, 0.06);
`;

export const BusinessName = styled(Typography)`
  font-weight: 600;
  font-size: 0.875rem;
  color: #1e293b;
  line-height: 1.25;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ServiceTypeRow = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
`;

export const SubserviceIconWrap = styled(Box)`
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MetaChips = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
  min-width: 0;
  align-content: flex-start;
`;

export const CardContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const ServiceTitle = styled(Typography)`
  font-weight: 700;
  font-size: 1.1rem;
  line-height: 1.3;
  color: #0f172a;
  letter-spacing: -0.01em;
`;

export const GroupBlurb = styled(Typography)`
  font-size: 0.75rem;
  line-height: 1.45;
  color: #64748b;
  margin-top: 6px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const PricingRow = styled(Box)`
  margin-top: 12px;
  flex-shrink: 0;
`;

export const DescriptionContainer = styled(Box)`
  flex: 1;
  overflow-y: auto;
  margin-top: 10px;
  padding-right: 4px;
  min-height: 48px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 2px;
  }
`;

export const CTAButtons = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;

  button {
    font-weight: 700;
    text-transform: none;
    border-radius: 10px;
    box-shadow: none;
    transition: background-color 0.2s ease, border-color 0.2s ease, filter 0.15s ease;
  }

  .MuiButton-contained {
    color: #ffffff;
    background: linear-gradient(90deg, #01ebb2 0%, #0d4efe 100%);
    box-shadow: 0 4px 14px rgba(13, 78, 254, 0.25);
  }

  .MuiButton-contained:hover {
    filter: brightness(1.05);
    box-shadow: 0 6px 18px rgba(13, 78, 254, 0.35);
  }

  .MuiButton-outlined {
    color: #1a1a2e;
    border: 1.5px solid #1a1a2e;
  }

  .MuiButton-outlined:hover {
    color: #0d4efe;
    border-color: #0d4efe;
    background: #ffffff;
  }
`;
